module.exports = __webpack_public_path__ + "static/media/forms_blue.ae97e638.svg";